import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'unsafeHtml'
})
export class UnsafeHtmlPipe implements PipeTransform {
  private readonly domSanitizer = inject(DomSanitizer);

  public transform(value: string | undefined): SafeHtml {
    if (value === undefined) {
      return '';
    }

    return this.domSanitizer.bypassSecurityTrustHtml(value);
  }
}
